import { render, staticRenderFns } from "./PartySeatComponent.vue?vue&type=template&id=c24773f0&scoped=true"
import script from "./PartySeatComponent.vue?vue&type=script&lang=js"
export * from "./PartySeatComponent.vue?vue&type=script&lang=js"
import style0 from "./PartySeatComponent.vue?vue&type=style&index=0&id=c24773f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24773f0",
  null
  
)

export default component.exports